import React from 'react';
import {
  Modal, Form, Checkbox, Row,
} from 'antd';
import PropTypes from 'prop-types';

const ModalFormComponent = ({
  visible, onCancel, onAccept, form, iataList, currentIata, flightAmount,
}) => {
  const { getFieldDecorator } = form;

  return (
    <Modal visible={visible} title="Clonar Vuelos" okText="Clonar" onCancel={onCancel} onOk={onAccept}>
      <Form layout="vertical">
        <Form.Item label={`Selecciona la(s) ciudad(es) de origen donde quieras clonar (${flightAmount}) oferta(s)`}>
          {getFieldDecorator('iatagroup', {
            initialValue: [],
          })(
            <Checkbox.Group>
              {iataList.map(
                (name, i) => currentIata !== name && (
                <Row>
                  <Checkbox value={i}>{name}</Checkbox>
                </Row>
                ),
              )}
            </Checkbox.Group>,
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

ModalFormComponent.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  iataList: PropTypes.array.isRequired,
  currentIata: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  flightAmount: PropTypes.number.isRequired,
};

ModalFormComponent.defaultProps = {
  currentIata: '',
};

const CloneSelectionModal = Form.create({ name: 'modal_form' })(ModalFormComponent);

export default CloneSelectionModal;
